import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, X } from "lucide-react";
import { money } from "@/lib/api";

export const EditableTable = ({ rows = [], columns, editing, onChange, testId, currency }) => {
  const update = (i, key, val, type) => {
    const next = rows.map((r, idx) => (idx === i ? { ...r, [key]: type === "money" || type === "number" ? Number(val) : val } : r));
    onChange(next);
  };
  const fmt = (v, type) => (type === "money" ? money(v, currency) : v);
  return (
    <div className="overflow-x-auto rounded-lg border border-slate-800" data-testid={testId}>
      <table className="w-full text-sm">
        <thead className="bg-slate-950/60">
          <tr>{columns.map((c) => <th key={c.key} className="text-left px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-semibold">{c.label}</th>)}{editing && <th />}</tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className="border-t border-slate-800/80">
              {columns.map((c) => (
                <td key={c.key} className={`px-4 py-2 align-top ${c.type === "money" || c.type === "number" ? "num" : "text-slate-300"}`}>
                  {editing ? (
                    <Input data-testid={`${testId}-cell-${i}-${c.key}`} type={c.type === "money" || c.type === "number" ? "number" : "text"}
                      value={r[c.key] ?? ""} onChange={(e) => update(i, c.key, e.target.value, c.type)} className="h-8 bg-slate-950/60 border-slate-700" />
                  ) : fmt(r[c.key], c.type)}
                </td>
              ))}
              {editing && (
                <td className="px-2"><Button size="icon" variant="ghost" data-testid={`${testId}-remove-${i}`} onClick={() => onChange(rows.filter((_, idx) => idx !== i))}><X className="h-4 w-4" /></Button></td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {editing && (
        <Button variant="ghost" size="sm" data-testid={`${testId}-add-row`} className="m-2 text-emerald-400"
          onClick={() => onChange([...rows, Object.fromEntries(columns.map((c) => [c.key, c.type === "money" || c.type === "number" ? 0 : ""]))])}>
          <Plus className="h-4 w-4 mr-1" />Add row
        </Button>
      )}
    </div>
  );
};
